import { applyMiddleware, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import reducers from '../reducers';

const persistConfig = {
  key: 'liveli',
  storage,
  blacklist: [
    'form',
    'eventsReducer'
  ],
  persist: [],
}

const pReducer = persistReducer(persistConfig, reducers);
export const store = createStore(
  pReducer,
  applyMiddleware(thunk)
);

export const persist = persistStore(store);